import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export default function DenemeInceleme({ apiUrl, onGeri, onSoruSec }) {
  const { authFetch } = useAuth();
  const [denemeler, setDenemeler] = useState([]);
  const [seciliDeneme, setSeciliDeneme] = useState(null);
  const [denemeSorular, setDenemeSorular] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => {
    async function yukle() {
      setYukleniyor(true);
      try {
        const r = await authFetch(`${apiUrl}/api/analiz/deneme-listesi`);
        const data = await r.json();
        const satirlar = data.satirlar || [];

        // deneme_no'ya gore aggregate satirlardan ozet kur
        const denemeMap = {};
        satirlar.forEach(row => {
          const dNo = row.deneme_no;
          if (!denemeMap[dNo]) denemeMap[dNo] = { no: dNo, soru_sayisi: 0, sinav: '', cevap_dagilimi: { A: 0, B: 0, C: 0, D: 0, E: 0 } };
          denemeMap[dNo].soru_sayisi += row.adet;
          if (!denemeMap[dNo].sinav && row.ders) {
            denemeMap[dNo].sinav = row.ders.startsWith('ayt') ? 'AYT' : 'TYT';
          }
          const c = (row.dogru_cevap || '').toUpperCase();
          if (denemeMap[dNo].cevap_dagilimi[c] !== undefined) {
            denemeMap[dNo].cevap_dagilimi[c] += row.adet;
          }
        });

        setDenemeler(Object.values(denemeMap).sort((a, b) => b.no - a.no));
      } catch (e) { console.error(e); }
      setYukleniyor(false);
    }
    yukle();
  }, [apiUrl, authFetch]);

  const denemeSec = async (deneme) => {
    setSeciliDeneme(deneme);
    setDenemeSorular([]);
    try {
      const r = await authFetch(`${apiUrl}/api/sorular?deneme_no=${deneme.no}&limit=200`);
      const data = await r.json();
      const sorular = data.sorular || [];
      setDenemeSorular(sorular.sort((a, b) => (a.soru_no || 0) - (b.soru_no || 0)));
    } catch (e) { console.error(e); }
  };

  // Cevap dagilimi hesapla
  const cevapDagilimi = (sorular) => {
    const d = { A: 0, B: 0, C: 0, D: 0, E: 0 };
    sorular.forEach(s => { const c = (s.dogru_cevap || '').toUpperCase(); if (d[c] !== undefined) d[c]++; });
    return d;
  };

  // Zorluk dagilimi
  const zorlukDagilimi = (sorular) => {
    const d = { kolay: 0, orta: 0, zor: 0, uzman: 0 };
    sorular.forEach(s => { const z = s.zorluk; if (d[z] !== undefined) d[z]++; });
    return d;
  };

  // Konu dagilimi
  const konuDagilimi = (sorular) => {
    const d = {};
    sorular.forEach(s => { const k = s.konu || 'Diger'; d[k] = (d[k] || 0) + 1; });
    return d;
  };

  const durumRenk = (d) => ({
    onaylandi: 'text-green-600', reddedildi: 'text-red-600'
  }[d] || 'text-yellow-600');

  const durumIcon = (d) => ({
    onaylandi: '\u2705', reddedildi: '\u274C'
  }[d] || '\u23F3');

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <button onClick={onGeri} className="text-blue-600 hover:text-blue-800 font-bold">&larr; Geri</button>
        <h2 className="text-xl font-bold text-gray-800">Deneme Inceleme</h2>
      </div>

      {yukleniyor ? (
        <div className="text-center text-gray-500 py-10">Yukleniyor...</div>
      ) : !seciliDeneme ? (
        /* Deneme Listesi */
        <div className="space-y-3">
          {denemeler.length === 0 ? (
            <div className="text-center text-gray-400 py-10">Henuz deneme yok. CLI ile deneme olusturun.</div>
          ) : denemeler.map(d => (
            <div key={d.no} onClick={() => denemeSec(d)}
              className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-all">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-lg font-bold text-gray-800">{d.sinav} Deneme #{d.no}</h3>
                  <span className="text-sm text-gray-500">{d.soru_sayisi} soru</span>
                </div>
                <div className="text-right">
                  <div className="text-xs text-gray-400">Cevap: {Object.entries(d.cevap_dagilimi).map(([k, v]) => `${k}:${v}`).join(' ')}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        /* Deneme Detay */
        <div>
          <div className="flex items-center gap-3 mb-4">
            <button onClick={() => setSeciliDeneme(null)} className="text-blue-600 hover:text-blue-800 text-sm">&larr; Denemeler</button>
            <h3 className="text-lg font-bold">{seciliDeneme.sinav} Deneme #{seciliDeneme.no} — {denemeSorular.length} Soru</h3>
          </div>

          {/* Ozet Istatistikler */}
          <div className="grid grid-cols-3 gap-4 mb-6">
            {/* Zorluk */}
            <div className="bg-white rounded-xl p-4 shadow-sm border">
              <h4 className="text-sm font-semibold text-gray-600 mb-2">Zorluk Dagilimi</h4>
              {Object.entries(zorlukDagilimi(denemeSorular)).map(([z, c]) => (
                <div key={z} className="flex justify-between text-sm">
                  <span className="capitalize">{z}</span>
                  <span className="font-mono">{c}</span>
                </div>
              ))}
            </div>

            {/* Cevap */}
            <div className="bg-white rounded-xl p-4 shadow-sm border">
              <h4 className="text-sm font-semibold text-gray-600 mb-2">Cevap Dagilimi</h4>
              {Object.entries(cevapDagilimi(denemeSorular)).map(([c, n]) => (
                <div key={c} className="flex justify-between text-sm">
                  <span className="font-bold">{c}</span>
                  <span className={`font-mono ${n === 8 ? 'text-green-600' : Math.abs(n - 8) <= 1 ? 'text-yellow-600' : 'text-red-600'}`}>{n}</span>
                </div>
              ))}
            </div>

            {/* Konu */}
            <div className="bg-white rounded-xl p-4 shadow-sm border">
              <h4 className="text-sm font-semibold text-gray-600 mb-2">Konu Dagilimi</h4>
              <div className="max-h-32 overflow-y-auto">
                {Object.entries(konuDagilimi(denemeSorular)).sort((a, b) => b[1] - a[1]).map(([k, c]) => (
                  <div key={k} className="flex justify-between text-xs">
                    <span className="truncate mr-2">{k}</span>
                    <span className="font-mono">{c}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Soru Tablosu */}
          <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-2 text-left">#</th>
                  <th className="px-3 py-2 text-left">Konu</th>
                  <th className="px-3 py-2 text-center">Zorluk</th>
                  <th className="px-3 py-2 text-center">Cevap</th>
                  <th className="px-3 py-2 text-center">Durum</th>
                  <th className="px-3 py-2 text-center">Incele</th>
                </tr>
              </thead>
              <tbody>
                {denemeSorular.map((s, i) => (
                  <tr key={s.id} className="border-t border-gray-50 hover:bg-blue-50">
                    <td className="px-3 py-2 font-mono text-gray-500">{i + 1}</td>
                    <td className="px-3 py-2">{s.konu}</td>
                    <td className="px-3 py-2 text-center">
                      <span className={`text-xs px-2 py-0.5 rounded ${s.zorluk === 'kolay' ? 'bg-green-100' : s.zorluk === 'zor' ? 'bg-red-100' : 'bg-yellow-100'}`}>
                        {s.zorluk}
                      </span>
                    </td>
                    <td className="px-3 py-2 text-center font-bold">{s.dogru_cevap}</td>
                    <td className={`px-3 py-2 text-center ${durumRenk(s.durum)}`}>{durumIcon(s.durum)}</td>
                    <td className="px-3 py-2 text-center">
                      {onSoruSec && (
                        <button onClick={() => onSoruSec(s.id)} className="text-blue-600 hover:underline text-xs">Gor</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
